export const PointIconP = () => {

    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_1265_6254)">
                <circle cx="10" cy="8" r="7.5" fill="url(#paint0_radial_1265_6254)" stroke="url(#paint1_linear_1265_6254)" />
                <path d="M7.5 12.5V4H10.8535C11.4982 4 12.0474 4.12313 12.5012 4.36938C12.955 4.61287 13.3009 4.95182 13.5388 5.38623C13.7795 5.81787 13.8999 6.31592 13.8999 6.88037C13.8999 7.44482 13.7782 7.94287 13.5347 8.37451C13.2912 8.80615 12.9384 9.14233 12.4763 9.38306C12.017 9.62378 11.4609 9.74414 10.8079 9.74414H8.67041V8.30395H10.5173C10.8632 8.30395 11.1482 8.24447 11.3723 8.12549C11.5992 8.00374 11.768 7.83634 11.8787 7.62329C11.9921 7.40747 12.0488 7.15983 12.0488 6.88037C12.0488 6.59814 11.9921 6.35189 11.8787 6.1416C11.768 5.92855 11.5992 5.76392 11.3723 5.64771C11.1454 5.52873 10.8577 5.46924 10.509 5.46924H9.29712V12.5H7.5Z" fill="url(#paint2_linear_1265_6254)" />
            </g>
            <defs>
                <filter id="filter0_d_1265_6254" x="0" y="0" width="20" height="20" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="2" />
                    <feGaussianBlur stdDeviation="1" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.952941 0 0 0 0 0.721569 0 0 0 0 0.239216 0 0 0 0.16 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1265_6254" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1265_6254" result="shape" />
                </filter>
                <radialGradient id="paint0_radial_1265_6254" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(9.93043 7.16522) rotate(89.5489) scale(8.83506 9.79058)">
                    <stop stop-color="#F2CA3C" />
                    <stop offset="1" stop-color="#F2AA3C" />
                </radialGradient>
                <linearGradient id="paint1_linear_1265_6254" x1="14.2435" y1="15.6522" x2="4.22609" y2="2.64348" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#C89137" />
                    <stop offset="1" stop-color="#FFF500" stop-opacity="0.2" />
                </linearGradient>
                <linearGradient id="paint2_linear_1265_6254" x1="10.7" y1="4" x2="10.7" y2="12.5" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#FEF7E6" />
                    <stop offset="1" stop-color="#FFFFFD" />
                </linearGradient>
            </defs>
        </svg>

    );
};